import { useCallback, useEffect, useRef, useState } from 'react';
import { Group } from '../../../../../containers';
import { Fade } from '../../../../../foundations/transitions';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { useCalendarContext } from '../../CalendarContext';
import { useKeyDown } from '../../hooks';
import { YearSelectionHeaderTrigger } from './YearSelectionHeaderTrigger';
import { YearSelectionListItem } from './YearSelectionListItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var YearSelection = _ref => {
  var {
    activeMonth,
    closeYearSelection
  } = _ref;
  var {
    size,
    isMobileDatePicker,
    years,
    showYearSelection
  } = useCalendarContext();
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  });
  var [expandedYear, setExpandedYear] = useState(activeMonth.year);
  var listRef = useRef(null); // Used to set the focus to the trigger button when the year selection is opened and visible.

  var currentYearSelectionBtnRef = useRef(null);
  var [initiated, setInitiated] = useState(false); // This is used to set the focus to trigger button when the year selection is opened and visible.

  useEffect(() => {
    var _currentYearSelection;

    (_currentYearSelection = currentYearSelectionBtnRef.current) === null || _currentYearSelection === void 0 ? void 0 : _currentYearSelection.focus();
  }, []);

  var handleToggleItem = (year, refToScroll) => {
    if (expandedYear === year) {
      setExpandedYear(undefined);
    } else {
      setExpandedYear(year);

      if (refToScroll) {
        scrollToElement(refToScroll);
      }
    }
  };

  var [focusedYear, setFocusedYear] = useState();
  var scrollToElement = useCallback(itemRef => {
    if (listRef.current && itemRef.current) {
      var containerRect = listRef.current.getBoundingClientRect();
      var elementRect = itemRef.current.getBoundingClientRect();
      var offset = elementRect.top - containerRect.top;
      listRef.current.scrollTo({
        top: listRef.current.scrollTop + offset,
        // we want to avoid smooth scroll when the user opens the year selection for the first time and when focus the year with the keyboard.
        behavior: initiated && itemRef.current.ariaExpanded !== 'false' ? 'smooth' : 'auto'
      });
    }

    setInitiated(true);
  }, [initiated]);

  var focusDefaultYear = () => {
    var _currentYearSelection2;

    (_currentYearSelection2 = currentYearSelectionBtnRef.current) === null || _currentYearSelection2 === void 0 ? void 0 : _currentYearSelection2.blur();
    setFocusedYear(expandedYear !== null && expandedYear !== void 0 ? expandedYear : activeMonth.year);
  };

  var handleFocusYearChange = (year, refToScroll) => {
    setFocusedYear(year);

    if (refToScroll) {
      scrollToElement(refToScroll);
    }
  };

  var handleEscape = () => {
    closeYearSelection();
  };

  var {
    onKeyDown
  } = useKeyDown({
    handleArrowKey: key => {
      if (key !== 'ArrowDown') return;
      focusDefaultYear();
    },
    handleFocus: focusDefaultYear,
    handleSelectKey: handleEscape,
    handleEscape
  });
  return /*#__PURE__*/_jsx(Box, {
    __css: styles['yearSelectionContainer'],
    "data-testid": "year-selection",
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "s",
      height: "full",
      children: [/*#__PURE__*/_jsx(Group, {
        width: "full",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(YearSelectionHeaderTrigger, {
          activeMonth: activeMonth,
          toggleYearSelection: handleEscape,
          "data-testid": "year-selection-header-close-trigger",
          ref: currentYearSelectionBtnRef,
          onKeyDown: onKeyDown
        })
      }), /*#__PURE__*/_jsx(Box, {
        __css: styles['yearSelectionList'],
        "data-testid": "year-selection-list",
        ref: listRef // Uses to A11y to announce the year selection menu and its orientation.
        ,
        role: "menu",
        "aria-orientation": "vertical",
        "aria-label": "Year Selection List",
        children: /*#__PURE__*/_jsx(Fade, {
          in: showYearSelection,
          children: years && /*#__PURE__*/_jsx(_Fragment, {
            children: Object.keys(years).map(year => {
              var yearItem = years[Number(year)];
              var isOpen = expandedYear === Number(year);
              if (!yearItem) return null;
              return /*#__PURE__*/_jsx(YearSelectionListItem, {
                yearItem: yearItem,
                isOpen: isOpen,
                goToYear: closeYearSelection,
                activeMonth: activeMonth,
                onToggleYear: handleToggleItem,
                scrollToElement: scrollToElement,
                focusedYear: focusedYear,
                onFocusYearChange: handleFocusYearChange,
                onBlurYear: () => {
                  var _currentYearSelection3;

                  // returns the focus to the trigger button.
                  (_currentYearSelection3 = currentYearSelectionBtnRef.current) === null || _currentYearSelection3 === void 0 ? void 0 : _currentYearSelection3.focus();
                },
                isActiveYear: activeMonth.year === yearItem.year,
                shouldTriggerScrollToElement: isOpen && !initiated,
                handleEscape: handleEscape
              }, year);
            })
          })
        })
      })]
    })
  });
};
YearSelection.displayName = 'YearSelection';
//# sourceMappingURL=YearSelection.js.map